"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiningExpedition = void 0;
var CardType_1 = require("../CardType");
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var constants_1 = require("../../constants");
var PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var RemoveAnyPlants_1 = require("../../deferredActions/RemoveAnyPlants");
var CardRenderer_1 = require("../render/CardRenderer");
var MiningExpedition = (function (_super) {
    __extends(MiningExpedition, _super);
    function MiningExpedition() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.MINING_EXPEDITION,
            cost: 12,
            metadata: {
                cardNumber: '063',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.oxygen(1).br;
                    b.minus().plants(-2).any;
                    b.steel(2);
                }),
                description: 'Raise oxygen 1 step. Remove 2 plants from any player. Gain 2 steel.',
            },
        }) || this;
    }
    MiningExpedition.prototype.canPlay = function (player) {
        var oxygenMaxed = player.game.getOxygenLevel() === constants_1.MAX_OXYGEN_LEVEL;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player.game, PartyName_1.PartyName.REDS) && !oxygenMaxed) {
            return player.canAfford(player.getCardCost(this) + constants_1.REDS_RULING_POLICY_COST);
        }
        return true;
    };
    MiningExpedition.prototype.play = function (player) {
        player.game.defer(new RemoveAnyPlants_1.RemoveAnyPlants(player, 2));
        player.steel += 2;
        return player.game.increaseOxygenLevel(player, 1);
    };
    return MiningExpedition;
}(Card_1.Card));
exports.MiningExpedition = MiningExpedition;
//# sourceMappingURL=MiningExpedition.js.map